export default __webpack_public_path__ + "static/media/ad_spend-min.1808d79e.png";